
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(276|497|568)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
